import { z } from "zod";

import type {
  DELIVERY_PROPOSAL_CONTRACT_STATUS,
  OFFER_CARGO_PROCESS_RECEPTION_STATUS,
} from "@/features/offer-cargo-process-status/badge-status";
import type { JP_CITIES } from "@/shared/constants/address";
import type {
  OFFER_CARGO_VEHICLE_SHAPES_LIST,
  VEHICLE_SIZES,
} from "@/shared/constants/offer-cargo";

export type JP_PREFECTURE_TYPES = keyof typeof JP_CITIES;
export type VEHICLE_SHAPE_TYPE =
  (typeof OFFER_CARGO_VEHICLE_SHAPES_LIST)[0]["value"];
export type VEHICLE_SIZE_TYPE = (typeof VEHICLE_SIZES)[0]["value"];

export const OfferCargoSearchFormSchema = z.object({
  companyName: z.string().optional(),
  loadingOnFrom: z.string().optional(),
  loadingOnTo: z.string().optional(),
  loadingPrefecture: z
    .string()
    .transform((v) => v as JP_PREFECTURE_TYPES)
    .optional(),
  loadingAddress: z.string().optional(),
  unloadingOnFrom: z.string().optional(),
  unloadingOnTo: z.string().optional(),
  unloadingPrefecture: z
    .string()
    .transform((v) => v as JP_PREFECTURE_TYPES)
    .optional(),
  unloadingAddress: z.string().optional(),
  receptionStatus: z
    .string()
    .transform((v) => v as OFFER_CARGO_PROCESS_RECEPTION_STATUS)
    .optional(),
  contractStatus: z
    .string()
    .transform((v) => v as DELIVERY_PROPOSAL_CONTRACT_STATUS)
    .optional(),
});

export type OfferCargoSearchFormSchemaType = z.infer<
  typeof OfferCargoSearchFormSchema
>;
